export default __webpack_public_path__ + "static/media/ImgPrincipal.cbb79332.png";